<ng-container *ngIf="callout !== null; else prose">
  <div class="card-callout" [ngClass]="calloutClass" role="note">
    <ion-icon class="card-callout__icon" name="alert-circle-outline" aria-hidden="true"></ion-icon>
    <p class="card-callout__text">{{ callout }}</p>
  </div>
</ng-container>

<ng-template #prose>
  <div class="card-text card-markdown" [innerHTML]="text | novaMarkdown"></div>
</ng-template>
